import {ROOT_PROJECT_ID} from '../../../../types'
import type {PolicyEntry} from '../CleanupProjectPage.types'

import {actions, defaultState, ERROR_MESSAGES} from './EditForm.constants'
import type {Action, EditFormState} from './EditForm.types'
import {calculateEntityDefaults} from './EditForm.utils'

export const getInitialState = (policy: PolicyEntry | null | undefined): EditFormState => {
  if (!policy) {
    return defaultState
  }

  const {artifactsPolicy, historyPolicy, everythingPolicy, options, externalId} = policy
  let dependencies: EditFormState['dependencies'] | null =
    options.ownPrevent || externalId === ROOT_PROJECT_ID ? null : 'default'

  if (dependencies == null) {
    dependencies = options.preventDependenciesArtifactsFromCleanup ? 'prevent' : 'do_not_prevent'
  }

  const history = calculateEntityDefaults(historyPolicy) ?? defaultState.history
  const everything = calculateEntityDefaults(everythingPolicy) ?? defaultState.everything
  const artifactsValue = calculateEntityDefaults(artifactsPolicy) ?? defaultState.artifacts
  const artifacts = {
    ...artifactsValue,
    pattern: artifactsPolicy?.policyParameters.artifactPatterns || '',
  }
  return {
    artifacts,
    history,
    everything,
    dependencies,
  }
}
export function reducer(state: EditFormState, action: Action): EditFormState {
  switch (action.type) {
    case actions.SET_CUSTOM:
      return {
        ...state,
        [action.entity]: {...state[action.entity], custom: action.value === 'custom'},
      }

    case actions.SET_DEPENDENCIES:
      return {...state, dependencies: action.value}

    case actions.SET_VALUE:
      let error = null

      if (action.value != null && Number(action.value) <= 0) {
        error = ERROR_MESSAGES.not_positive
      }

      return {
        ...state,
        [action.entity]: {...state[action.entity], [action.kind]: action.value, error},
      }

    case actions.SET_ERROR:
      return {...state, [action.entity]: {...state[action.entity], error: action.error}}

    case actions.SET_ARTIFACTS_VALUE:
      return {...state, artifacts: {...state.artifacts, pattern: action.value}}

    default:
      throw Error
  }
}
